import {exeRequest} from '../utils/APIUtils'
import { LOCAL_STORAGE_KEYS } from '../constants';

export default {
 getAll : async  () => (await exeRequest("/list/produit", "GET"))
}